(function () {
    const search = document.getElementById("FilterBarSearch");
    const clearBtn = document.getElementById("FilterBarClear");
    const dropdowns = document.querySelectorAll(".FilterBar__dropdown");
    const resultsContainer = document.getElementById("ProjectsResults");
    const selectedTagsContainer = document.getElementById("FilterBarSelected");
    const sentinel = document.getElementById("ProjectsLoadMoreSentinel");

    if (!search || !clearBtn || dropdowns.length === 0 || !resultsContainer || !selectedTagsContainer || !sentinel) {
        return;
    }

    let currentPage = 1;
    let hasMore = true;
    let isLoading = false;
    let searchDebounce = null;
    let currentRequestId = 0;

    function closeAll() {
        dropdowns.forEach(dropdown => {
            dropdown.classList.remove("is-open");

            const dropdownSearch = dropdown.querySelector(".FilterBar__dropdownSearch--trigger");
            if (dropdownSearch && !getDropdownValues(dropdown).length) {
                dropdownSearch.value = "";
            }

            filterDropdownItems(dropdown, dropdownSearch ? dropdownSearch.value : "");
        });
    }

    function getDropdownValues(dropdown) {
        try {
            return JSON.parse(dropdown.dataset.values || "[]");
        } catch (e) {
            return [];
        }
    }

    function setDropdownValues(dropdown, values) {
        dropdown.dataset.values = JSON.stringify(values);
    }

    function hasAnyValue() {
        if (search.value.trim()) return true;

        return Array.from(dropdowns).some(dropdown => {
            return getDropdownValues(dropdown).length > 0;
        });
    }

    function syncClear() {
        clearBtn.disabled = !hasAnyValue();
    }

    function renderSelectedTags() {
        selectedTagsContainer.innerHTML = "";

        dropdowns.forEach(dropdown => {
            const dropdownName = dropdown.dataset.name;
            const values = getDropdownValues(dropdown);

            values.forEach(value => {
                const item = dropdown.querySelector(`li[data-value="${value}"]`);
                const text = item ? item.textContent.trim() : value;

                const tag = document.createElement("div");
                tag.className = "FilterBar__tag";

                tag.innerHTML = `
                    <span>${text}</span>
                    <button type="button" data-dropdown="${dropdownName}" data-value="${value}">
                        <span>×</span>
                    </button>
                `;

                selectedTagsContainer.appendChild(tag);
            });
        });
    }

    function buildFormData(page = 1) {
        const formData = new FormData();
        formData.append("action", "filter_projects");
        formData.append("nonce", projectsAjax.nonce);
        formData.append("search", search.value.trim());
        formData.append("page", page);

        dropdowns.forEach(dropdown => {
            const name = dropdown.dataset.name;
            const values = getDropdownValues(dropdown);

            values.forEach(value => {
                formData.append(name + "[]", value);
            });
        });

        return formData;
    }

    function showInitialLoading() {
        resultsContainer.innerHTML = "<p>Loading...</p>";
    }

    function showAppendLoading() {
        if (!document.getElementById("ProjectsLoadingMore")) {
            const el = document.createElement("p");
            el.id = "ProjectsLoadingMore";
            el.textContent = "Loading more...";
            el.style.width = "100%";
            el.style.marginTop = "20px";
            resultsContainer.appendChild(el);
        }
    }

    function hideAppendLoading() {
        const el = document.getElementById("ProjectsLoadingMore");
        if (el) el.remove();
    }

    function sentinelIsNearViewport() {
        const rect = sentinel.getBoundingClientRect();
        return rect.top <= window.innerHeight + 1000;
    }

    function filterDropdownItems(dropdown, term) {
        const items = dropdown.querySelectorAll(".FilterBar__dropdownMenu li");
        const normalized = (term || "").trim().toLowerCase();

        items.forEach((item, index) => {
            const value = item.dataset.value || "";
            const text = item.textContent.trim().toLowerCase();

            if (index === 0 && value === "") {
                item.classList.remove("is-hidden");
                return;
            }

            if (!normalized || text.includes(normalized)) {
                item.classList.remove("is-hidden");
            } else {
                item.classList.add("is-hidden");
            }
        });
    }

    function updateSearchableDropdownValue(dropdown) {
        const input = dropdown.querySelector(".FilterBar__dropdownSearch--trigger");
        if (!input) return;

        input.value = "";
        input.placeholder = "Clients";
    }

    async function runFilter({ append = false } = {}) {
        if (isLoading) return;
        if (append && !hasMore) return;

        isLoading = true;
        const requestId = ++currentRequestId;
        const pageToLoad = append ? currentPage + 1 : 1;

        if (append) {
            showAppendLoading();
        } else {
            showInitialLoading();
        }

        try {
            const response = await fetch(projectsAjax.ajax_url, {
                method: "POST",
                body: buildFormData(pageToLoad),
            });

            const data = await response.json();

            if (requestId !== currentRequestId) return;

            hideAppendLoading();

            if (!data.success) {
                if (!append) {
                    resultsContainer.innerHTML = "<p>Something went wrong.</p>";
                }
                return;
            }

            const html = data.data.html || "";

            if (append) {
                resultsContainer.insertAdjacentHTML("beforeend", html);
                currentPage = pageToLoad;
            } else {
                resultsContainer.innerHTML = html || "<p>No projects found.</p>";
                currentPage = 1;
            }

            hasMore = !!data.data.has_more;

            if (!append && !html) {
                resultsContainer.innerHTML = "<p>No projects found.</p>";
            }

            if (hasMore && sentinelIsNearViewport()) {
                requestAnimationFrame(() => {
                    runFilter({ append: true });
                });
            }

        } catch (error) {
            console.error("AJAX error:", error);
            hideAppendLoading();

            if (!append) {
                resultsContainer.innerHTML = "<p>Something went wrong.</p>";
            }
        } finally {
            isLoading = false;
        }
    }

    function resetAndRunFilter() {
        currentPage = 1;
        hasMore = true;
        runFilter({ append: false });
    }

    dropdowns.forEach(dropdown => {
        const toggle = dropdown.querySelector(".FilterBar__dropdownToggle");
        const items = dropdown.querySelectorAll(".FilterBar__dropdownMenu li");
        const searchableInput = dropdown.querySelector(".FilterBar__dropdownSearch--trigger");

        setDropdownValues(dropdown, []);

        if (toggle) {
            toggle.addEventListener("click", function (e) {
                e.stopPropagation();

                const isOpen = dropdown.classList.contains("is-open");
                closeAll();
                dropdown.classList.toggle("is-open", !isOpen);
            });
        }

        if (searchableInput) {
            searchableInput.addEventListener("click", function (e) {
                e.stopPropagation();
                closeAll();
                dropdown.classList.add("is-open");
            });

            searchableInput.addEventListener("focus", function (e) {
                e.stopPropagation();
                closeAll();
                dropdown.classList.add("is-open");
            });

            searchableInput.addEventListener("input", function (e) {
                dropdown.classList.add("is-open");
                filterDropdownItems(dropdown, searchableInput.value);
            });
        }

        items.forEach(item => {
            item.addEventListener("click", function (e) {
                e.stopPropagation();

                if (item.classList.contains("is-hidden")) return;

                const value = item.dataset.value || "";

                if (!value) {
                    setDropdownValues(dropdown, []);

                    if (searchableInput) {
                        searchableInput.value = "";
                        filterDropdownItems(dropdown, "");
                    }

                    updateSearchableDropdownValue(dropdown);
                    renderSelectedTags();
                    syncClear();
                    resetAndRunFilter();
                    return;
                }

                const currentValues = getDropdownValues(dropdown);
                const exists = currentValues.includes(value);

                const newValues = exists
                    ? currentValues.filter(v => v !== value)
                    : [...currentValues, value];

                setDropdownValues(dropdown, newValues);

                if (searchableInput) {
                    updateSearchableDropdownValue(dropdown);
                    filterDropdownItems(dropdown, "");
                    dropdown.classList.remove("is-open");
                }

                renderSelectedTags();
                syncClear();
                resetAndRunFilter();
            });
        });
    });

    selectedTagsContainer.addEventListener("click", function (e) {
        const button = e.target.closest("button[data-dropdown][data-value]");
        if (!button) return;

        const dropdownName = button.dataset.dropdown;
        const value = button.dataset.value;

        const dropdown = document.querySelector(`.FilterBar__dropdown[data-name="${dropdownName}"]`);
        if (!dropdown) return;

        const currentValues = getDropdownValues(dropdown);
        const newValues = currentValues.filter(v => v !== value);

        setDropdownValues(dropdown, newValues);
        updateSearchableDropdownValue(dropdown);
        renderSelectedTags();
        syncClear();
        resetAndRunFilter();
    });

    clearBtn.addEventListener("click", function () {
        search.value = "";

        dropdowns.forEach(dropdown => {
            setDropdownValues(dropdown, []);
            updateSearchableDropdownValue(dropdown);

            const searchableInput = dropdown.querySelector(".FilterBar__dropdownSearch--trigger");
            if (searchableInput) {
                searchableInput.value = "";
                filterDropdownItems(dropdown, "");
            }
        });

        renderSelectedTags();
        syncClear();
        resetAndRunFilter();
    });

    search.addEventListener("input", function () {
        syncClear();

        clearTimeout(searchDebounce);
        searchDebounce = setTimeout(() => {
            resetAndRunFilter();
        }, 250);
    });

    document.addEventListener("click", closeAll);

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && hasMore && !isLoading) {
                runFilter({ append: true });
            }
        });
    }, {
        root: null,
        rootMargin: "1000px 0px",
        threshold: 0
    });

    observer.observe(sentinel);

    renderSelectedTags();
    syncClear();
    resetAndRunFilter();
})();